import React, { useState } from 'react'
import { hamburger, logo } from '../../assets/images'
import CloseIcon from '@mui/icons-material/Close';
import styles from './Nav.module.css'
import { useNavigate } from 'react-router-dom';
const Nav = () => {
  const [sideNav, setSideNav] = useState(false)

  const navItems = ["about", "Projects", "Resume", "Services", "Contact"]
  const navigate = useNavigate();

  return (
    <nav className=''>
      <div className="container md:pl-[61px] md:pr-[57px] p-[20px]">
        <div className='flex  text-white justify-between'>
          <button onClick={() => navigate("/")} className=' text-[.578rem] md:text-[1rem]'>
            <img src={logo} className="m-auto w-[20px] h-[20px] md:w-[44px] md:h-[44px]" alt="logo" />
            <p className='capitalize mt-[4px]'><span className='text-white'>sage</span> <span className='font-[1000] capitalize text-[#A6B2EC] tracking-wide bold'>Designs</span>  </p>
          </button>

          <img onClick={() => setSideNav(true)} src={hamburger} className="lg:hidden" alt="menu" />

          <div className='self-center m-auto hidden lg:block'>
            <ul className='text-white'>
              {navItems.map((navItem, index) => navItem !== "about" ? (

                <li key={index} className='inline capitalize ml-[3rem]'><a href={`#${navItem}`}>{navItem}</a></li>

              ) :
                (<li key={index} className='inline ml-[3rem]'><button onClick={() => navigate("/about")} className=' capitalize'>{navItem}</button></li>
                )
              )}

            </ul>
          </div>
        </div>
      </div>

      <div style={{ width: sideNav ? "100%" : "0%" }} className={`${styles.nav} fixed lg:hidden h-full z-50  top-0 flex`}>
        <ul className='text-white m-auto text-2xl text-center leading-[4rem]'>
          {navItems.map((navItem, index) => navItem !== "about" ? (
          <li key={index} onClick={()=>setSideNav(false)} className='capitalize'><a href={`#${navItem}`}>{navItem}</a></li>):(
          <li onClick={() => { navigate("/about"); setSideNav(false) }} key={index} className='capitalize'><a href={`#${navItem}`}>{navItem}</a></li>
          )
          
          
          )}
        </ul>

        <CloseIcon onClick={() => setSideNav(false)} className='absolute top-[4%] right-[5%] text-white' />

      </div>

    </nav>
  )
}

export default Nav


